import { isEmpty, pick } from 'lodash-es';

import runtimeConfig from '~config/config';
import {
    CATALOG_PAGE_SIZE,
    RECOMMENDATION_TRAY_PAGE_SIZE,
    RECENTLY_VIEWED_PAGE_SIZE,
} from '~modules/catalog/js/catalog-constants';
import { NUU_HEADER_LOCATION_OVERRIDE } from '~coreModules/core/js/constants';

const { apiUrls } = runtimeConfig;

export function getCatalogItems({
    r15Svc,
    catalogSlug,
    query = {},
    catalogFilterWhitelist = [],
    logger,
    dcOverride = null,
}) {
    if (isEmpty(catalogFilterWhitelist)) {
        logger.error('No catalogFilterWhitelist passed to GET getCatalogItems');
    }
    const whitelistedQuery = pick(query, catalogFilterWhitelist);
    const options = {
        params: {
            ...whitelistedQuery,
            pageNumber: whitelistedQuery.pageNumber || 1,
            itemsPerPage: whitelistedQuery.itemsPerPage || CATALOG_PAGE_SIZE,
        },
        ...(dcOverride && {
            headers: {
                [NUU_HEADER_LOCATION_OVERRIDE]: dcOverride,
            },
        }),
    };

    return r15Svc.get(`${apiUrls.catalogService}/${catalogSlug}`, options);
}

export function getRandomProductTray({
    r15Svc,
    catalogSlug,
    query = {},
    catalogFilterWhitelist = [],
    logger,
}) {
    if (isEmpty(catalogFilterWhitelist)) {
        logger.error('No catalogFilterWhitelist passed to GET getRandomProductTray');
    }
    const whitelistedQuery = pick(query, catalogFilterWhitelist);
    const options = {
        params: {
            ...whitelistedQuery,
            pageNumber: whitelistedQuery.pageNumber || 1,
            itemsPerPage: whitelistedQuery.itemsPerPage || CATALOG_PAGE_SIZE,
        },
    };

    return r15Svc.get(`${apiUrls.catalogService}/tray-group/${catalogSlug}`, options);
}

export function getSimilarProductsByChoiceId({ r15Svc, choiceId, query = {}, catalogFilterWhitelist = [], logger }) {
    if (isEmpty(catalogFilterWhitelist)) {
        logger?.error('No catalogFilterWhitelist passed to GET getSimilarProductsByChoiceId');
    }

    const whitelistedQuery = pick(query, catalogFilterWhitelist);

    const options = {
        params: {
            ...whitelistedQuery,
            pageNumber: whitelistedQuery.pageNumber || 1,
            itemsPerPage: whitelistedQuery.itemsPerPage || RECOMMENDATION_TRAY_PAGE_SIZE,
        },
    };

    return r15Svc.get(`${apiUrls.catalogService}/similar/${choiceId}`, options);
}

export function getVisuallySimilarProductsByChoiceId(
    {
        r15Svc,
        choiceId,
        recTrayType,
        query = {},
        catalogFilterWhitelist = [],
        logger,
    }) {
    if (isEmpty(catalogFilterWhitelist)) {
        logger?.error('No catalogFilterWhitelist passed to GET getVisuallySimilarProductsByChoiceId');
    }

    const whitelistedQuery = pick(query, catalogFilterWhitelist);

    const options = {
        params: {
            ...whitelistedQuery,
            pageNumber: whitelistedQuery.pageNumber || 1,
            itemsPerPage: whitelistedQuery.itemsPerPage || RECOMMENDATION_TRAY_PAGE_SIZE,
            recTrayType,
        },
    };

    return r15Svc.get(`${apiUrls.catalogService}/visuallySimilar/${choiceId}`, options);
}

export function getSearchItems({
    r15Svc,
    query = {},
    catalogFilterWhitelist = [],
    logger,
    dcOverride,
}) {
    if (isEmpty(catalogFilterWhitelist)) {
        logger?.error('No catalogFilterWhitelist passed to GET getSearchItems');
    }

    const whitelistedQuery = pick(query, catalogFilterWhitelist);

    const options = {
        params: {
            ...whitelistedQuery,
            pageNumber: whitelistedQuery.pageNumber || 1,
            itemsPerPage: whitelistedQuery.itemsPerPage || CATALOG_PAGE_SIZE,
        },
        ...(dcOverride && {
            headers: {
                [NUU_HEADER_LOCATION_OVERRIDE]: dcOverride,
            },
        }),
    };

    return r15Svc.get(`${apiUrls.catalogService}/search`, options);
}

export function getRecentlyViewedItems(r15Svc, choiceId = null) {
    return r15Svc.get(apiUrls.recentlyViewedService, {
        params: {
            itemsPerPage: RECENTLY_VIEWED_PAGE_SIZE,
            ...(choiceId && { currentChoice: choiceId }),
        },
    });
}
